import { Inject, Injectable, Optional } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { RouteQueryParams, UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ATLAS } from '../../../constants/injector.constants';
import { Atlas } from '../../atlas/atlas';
import { getNodesByUrl } from '../../atlas/atlas.helpers';

@Injectable()
export class AuthorizationGuard implements CanActivate {
    constructor(
        private _userService: UserService,
        private _router: Router,
        @Optional() @Inject(ATLAS) private _atlas?: Atlas
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const loginUrl =
            state.url === '' || state.url === '/'
                ? `/${UiRoutes.Login}`
                : `/${UiRoutes.Login}?${RouteQueryParams.TargetUrl}=${encodeURIComponent(
                      state.url
                  )}`;

        if (this._atlas) {
            const atlasNodesInOrder = getNodesByUrl(this._atlas, state.url);
            if (
                atlasNodesInOrder.length > 0 &&
                atlasNodesInOrder.every(({ allowAnonymous }) => allowAnonymous)
            ) {
                return of(true);
            }
        }

        return this._userService.user$.pipe(
            switchMap((user) => {
                if (user === null) {
                    return of(this._router.parseUrl(loginUrl));
                }

                return of(true);
            })
        );
    }
}
